// extracted by mini-css-extract-plugin
module.exports = {"logo":"terms_logo__3aqKn","title":"terms_title__2He2Q","link":"terms_link__2tlD7","button":"terms_button__2RfF7"};